// number fields: a typed comma becomes a decimal point, so "0,02" works in every browser language
document.addEventListener('keydown', (e) => {
  const el = e.target;
  if (e.key !== ',' || !(el instanceof HTMLInputElement) || el.type !== 'number') return;
  e.preventDefault();
  if (!String(el.value).includes('.')) document.execCommand('insertText', false, '.');
}, true);
